import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface DialogData {
  message: string;
  cancelButton: string;
  confirmButton: string;
}

@Component({
  selector: 'bimbo-cancel-confirm-dialog',
  templateUrl: './cancel-confirm-dialog.component.html',
  styleUrls: ['./cancel-confirm-dialog.component.scss']
})
export class CancelConfirmDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CancelConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
